// Router Dashboard - coach
export default [
  {
    path: 'my-leaders',
    name: 'myLeaders',
    component: () => import(/* webpackChunkName: "dashboard-coach" */ '../../../views/dashboard/content/coach/leaders/LeadersList.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        index: '100-0',
        label: 'aside.myLeaders',
        icon: 'el-icon-s-custom',
      },
    },
  },
  {
    path: 'my-leaders/:id',
    name: 'myLeaderDetail',
    component: () => import(/* webpackChunkName: "dashboard-coach" */ '../../../views/dashboard/content/coach/leaders/LeaderDetails.vue'),
    meta: {
      roles: ['coach', 'MAM'],
      navMenuOptions: {
        as: 'myLeaders',
      },
    },
  },
  {
    path: 'my-leaders/:id/pulse/',
    name: 'myLeaderPulseDetail',
    component: () => import(/* webpackChunkName: "dashboard-coach" */ '../../../views/dashboard/content/coach/leaders/pulse/LeaderPulseInfo.vue'),
    meta: {
      roles: ['coach', 'MAM'],
      navMenuOptions: {
        as: 'myLeaders',
      },
    },
  },
  {
    path: 'my-leaders/:id/action-plan',
    name: 'myLeaderActionPlan',
    component: () => import(/* webpackChunkName: "dashboard-coach" */ '../../../views/dashboard/content/leader/actionPlan/ActionPlanMain.vue'),
    meta: {
      roles: ['coach', 'MAM'],
      navMenuOptions: {
        as: 'myLeaders',
      },
    },
  },
  {
    path: 'my-leaders/:id/action-plan/set-up',
    name: 'myLeaderActionPlanSetUp',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/actionPlan/setup/ActionPlanSetUp.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        as: 'myLeaders',
      },
    },
  },
  {
    path: 'my-leaders/:id/coworkers',
    name: 'myLeaderCoworkers',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/stakeholders/StakeholdersMain.vue'),
    meta: {
      roles: ['coach', 'MAM'],
      navMenuOptions: {
        as: 'myLeaders',
      },
    },
  },
  {
    path: 'my-leaders/:id/feedforward',
    name: 'myLeaderFeedforward',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/feedforward/Feedforward.vue'),
    meta: {
      roles: ['coach', 'MAM'],
      navMenuOptions: {
        as: 'myLeaders',
      },
    },
  },
  {
    path: 'leader-engagements',
    name: 'leaderEngagementsList',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/coach/engagements/EngagementsList.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        parent: 'myLeaders',
        index: '100-1',
        label: 'aside.pastEngagements',
      },
    },
  },
  {
    path: 'leader-engagement/:id',
    name: 'leaderEngagementDetails',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/coach/engagements/EngagementDetails.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        as: 'leaderEngagementsList',
      },
    },
  },
  {
    path: 'engagement/:id/action-plan',
    name: 'leaderEngagementActionPlan',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/coach/engagements/EngagementActionPlan.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        as: 'leaderEngagementsList',
      },
    },
  },
  {
    path: 'engagement/:id/pulse',
    name: 'leaderEngagementPulse',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/coach/engagements/EngagementPulse.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        as: 'leaderEngagementsList',
      },
    },
  },
  {
    path: 'engagement/:id/feedforward',
    name: 'leaderEngagementFeedforward',
    component: () => import(/* webpackChunkName: "dashboard-leader" */ '../../../views/dashboard/content/leader/feedforward/Feedforward.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        as: 'leaderEngagementsList',
      },
    },
  },
  {
    path: 'calendar',
    name: 'calendar',
    component: () => import(/* webpackChunkName: "dashboard-coach" */ '../../../views/dashboard/content/coach/calendar/CalendarMain.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        index: '95',
        label: 'aside.calendar',
        icon: 'el-icon-date',
      },
    },
  },
  {
    path: 'calendar/:date',
    name: 'calendarToDate',
    component: () => import(/* webpackChunkName: "dashboard-coach" */ '../../../views/dashboard/content/coach/calendar/CalendarMain.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        index: '95',
        label: 'aside.calendar',
        icon: 'el-icon-date',
      },
    },
  },
  {
    path: 'invoice/coach',
    name: 'invoices',
    component: () => import(/* webpackChunkName: "dashboard-coach" */ '../../../views/dashboard/content/coach/invoices/InvoicesList.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        index: '103-0',
        label: 'aside.invoices',
        as: 'Invoices',
        icon: 'custom-invoices',
        standAlone: true,
        hideForNonAc: true,
      },
    },
  },
  {
    path: 'invoice/settings',
    name: 'invoiceInformation',
    component: () => import(/* webpackChunkName: "dashboard-coach" */ '../../../views/dashboard/content/common/settings/InvoiceInformation.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        parent: 'invoices',
        index: '103-10',
        label: 'aside.invoiceInfo',
        hideForNonAc: true,
      },
    },
  },
];
